// Emoji seti — npm bağımlılığı yok, unicode + Türkçe arama anahtarları.
export const EMOJI_CATEGORIES = [
  {
    key: 'smileys', label: 'Yüzler',
    items: [
      ['😀', 'gülümseme mutlu'], ['😃', 'mutlu sevinç'], ['😄', 'gülüş kahkaha'], ['😁', 'sırıtma'],
      ['😆', 'kahkaha gülme'], ['😅', 'gülme ter'], ['🤣', 'kahkaha yerlere'], ['😂', 'gözyaşı gülme'],
      ['🙂', 'hafif gülümseme'], ['🙃', 'ters yüz'], ['😉', 'göz kırpma'], ['😊', 'utangaç mutlu'],
      ['😇', 'melek'], ['🥰', 'aşık kalp'], ['😍', 'aşık gözler kalp'], ['🤩', 'yıldız hayran'],
      ['😘', 'öpücük'], ['😗', 'öpücük'], ['😚', 'öpücük'], ['😙', 'öpücük'],
      ['😋', 'lezzetli dil'], ['😛', 'dil'], ['😜', 'şaka dil'], ['🤪', 'çılgın'],
      ['🤨', 'şüpheli kaş'], ['🧐', 'monokl inceleme'], ['🤓', 'inek gözlük'], ['😎', 'havalı güneş gözlüğü'],
      ['🥳', 'kutlama parti'], ['😏', 'sırıtma kurnaz'], ['😒', 'sıkılmış'], ['😞', 'üzgün'],
      ['😔', 'düşünceli üzgün'], ['😟', 'endişeli'], ['😕', 'karışık'], ['🙁', 'üzgün'],
      ['😣', 'zorlanma'], ['😖', 'bunalmış'], ['😫', 'yorgun'], ['😩', 'bitkin'],
      ['🥺', 'yalvaran'], ['😢', 'ağlama'], ['😭', 'hüngür ağlama'], ['😤', 'öfke burun'],
      ['😠', 'kızgın'], ['😡', 'çok kızgın'], ['🤯', 'şok patlama'], ['😱', 'korku çığlık'],
      ['😨', 'korkmuş'], ['😰', 'endişe ter'], ['😥', 'üzgün rahatlama'], ['😓', 'ter'],
      ['🤗', 'sarılma'], ['🤔', 'düşünme'], ['🤭', 'kıkırdama'], ['🤫', 'sus'],
      ['🤥', 'yalan'], ['😶', 'sessiz'], ['😐', 'nötr'], ['😑', 'ifadesiz'],
      ['😬', 'sırıtma gergin'], ['🙄', 'göz devirme'], ['😯', 'şaşkın'], ['😦', 'şaşkın'],
      ['😧', 'endişe'], ['😮', 'şaşkın ağız'], ['😲', 'şok'], ['🥱', 'esneme uyku'],
      ['😴', 'uyku'], ['🤤', 'salya'], ['😪', 'uykulu'], ['😵', 'baygın'],
      ['🤐', 'ağzı kapalı'], ['🥴', 'sersem'], ['🤢', 'mide bulantısı'], ['🤮', 'kusma'],
      ['🤧', 'hapşırma'], ['😷', 'maske hasta'], ['🤒', 'ateş hasta'], ['🤕', 'yaralı'],
    ],
  },
  {
    key: 'gestures', label: 'El & Kişi',
    items: [
      ['👍', 'beğen başparmak onay olumlu'], ['👎', 'beğenme olumsuz'], ['👌', 'tamam ok'], ['✌️', 'zafer barış'],
      ['🤞', 'şans parmak'], ['🤟', 'seni seviyorum'], ['🤘', 'rock'], ['🤙', 'ara beni'],
      ['👈', 'sol'], ['👉', 'sağ'], ['👆', 'yukarı'], ['👇', 'aşağı'],
      ['☝️', 'işaret'], ['✋', 'dur el'], ['🤚', 'el'], ['🖐️', 'açık el'],
      ['🖖', 'vulkan'], ['👋', 'selam merhaba'], ['🤝', 'anlaşma tokalaşma'], ['🙏', 'teşekkür dua rica'],
      ['✍️', 'yazma'], ['💪', 'güç kas'], ['🦾', 'robot kol'], ['👏', 'alkış tebrik'],
      ['🙌', 'kutlama eller'], ['👐', 'açık eller'], ['🤲', 'avuç'], ['🤛', 'yumruk sol'],
      ['🤜', 'yumruk sağ'], ['✊', 'yumruk'], ['👊', 'yumruk'], ['🫡', 'selam asker'],
      ['🧑‍💻', 'yazılımcı bilgisayar'], ['👨‍🔧', 'teknisyen'], ['👷', 'inşaat işçi'], ['🕵️', 'dedektif'],
    ],
  },
  {
    key: 'work', label: 'İş & Ofis',
    items: [
      ['✅', 'tamam onay tik yapıldı'], ['☑️', 'işaretli'], ['✔️', 'tik'], ['❌', 'hayır iptal çarpı'],
      ['❎', 'çarpı'], ['⚠️', 'uyarı dikkat'], ['🚫', 'yasak'], ['⛔', 'giriş yok'],
      ['📌', 'sabitle raptiye'], ['📎', 'ataç dosya'], ['🗂️', 'dosya klasör'], ['📁', 'klasör'],
      ['📂', 'açık klasör'], ['📄', 'belge sayfa'], ['📃', 'doküman'], ['📑', 'sekmeli belge'],
      ['📊', 'grafik çubuk rapor'], ['📈', 'artış yükseliş'], ['📉', 'düşüş azalma'], ['📋', 'pano liste'],
      ['📅', 'takvim tarih'], ['📆', 'takvim'], ['🗓️', 'takvim'], ['⏰', 'alarm saat'],
      ['⏱️', 'kronometre süre'], ['⏳', 'kum saati bekleme'], ['💼', 'çanta iş'], ['🏢', 'ofis bina'],
      ['🏭', 'fabrika üretim'], ['🔧', 'anahtar tamir'], ['🔨', 'çekiç'], ['⚙️', 'dişli ayar'],
      ['🛠️', 'aletler bakım'], ['🔩', 'cıvata somun'], ['⚡', 'elektrik enerji hızlı'], ['🔌', 'fiş elektrik'],
      ['💡', 'fikir ampul'], ['🔍', 'ara büyüteç'], ['🔎', 'ara'], ['🔒', 'kilit özel'],
      ['🔑', 'anahtar'], ['💰', 'para kazanç'], ['💵', 'para dolar'], ['💶', 'euro para'],
      ['🧾', 'fatura fiş'], ['🏷️', 'etiket fiyat'], ['📦', 'kutu paket sevkiyat'], ['🚚', 'kamyon teslimat'],
      ['📧', 'e-posta mail'], ['📞', 'telefon arama'], ['📱', 'telefon mobil'], ['💻', 'bilgisayar laptop'],
    ],
  },
  {
    key: 'symbols', label: 'Semboller',
    items: [
      ['❤️', 'kalp aşk sevgi'], ['🧡', 'turuncu kalp'], ['💛', 'sarı kalp'], ['💚', 'yeşil kalp'],
      ['💙', 'mavi kalp'], ['💜', 'mor kalp'], ['🖤', 'siyah kalp'], ['🤍', 'beyaz kalp'],
      ['💯', 'yüz tam puan'], ['🔥', 'ateş harika süper'], ['⭐', 'yıldız favori'], ['🌟', 'parlak yıldız'],
      ['✨', 'parıltı yeni'], ['🎉', 'kutlama parti tebrik'], ['🎊', 'konfeti'], ['🎯', 'hedef'],
      ['🏆', 'kupa başarı ödül'], ['🥇', 'birinci altın'], ['🚀', 'roket hızlı lansman'], ['💎', 'elmas değerli'],
      ['🔔', 'zil bildirim'], ['🔕', 'sessiz bildirim'], ['📢', 'duyuru megafon'], ['📣', 'duyuru'],
      ['❓', 'soru'], ['❗', 'ünlem önemli'], ['➕', 'ekle artı'], ['➖', 'çıkar eksi'],
      ['♻️', 'geri dönüşüm'], ['🆗', 'tamam'], ['🆕', 'yeni'], ['🔝', 'en üst'],
    ],
  },
  {
    key: 'nature', label: 'Doğa & Yemek',
    items: [
      ['☀️', 'güneş'], ['🌤️', 'parçalı bulutlu'], ['☁️', 'bulut'], ['🌧️', 'yağmur'],
      ['⛈️', 'fırtına'], ['❄️', 'kar soğuk'], ['🌈', 'gökkuşağı'], ['🌙', 'ay gece'],
      ['🌍', 'dünya'], ['🌱', 'filiz büyüme'], ['🌳', 'ağaç'], ['🌸', 'çiçek'],
      ['🍀', 'yonca şans'], ['🐝', 'arı'], ['🐶', 'köpek'], ['🐱', 'kedi'],
      ['☕', 'kahve mola'], ['🍵', 'çay'], ['🍺', 'bira'], ['🍕', 'pizza'],
      ['🍔', 'burger'], ['🍎', 'elma'], ['🎂', 'pasta doğum günü'], ['🍫', 'çikolata'],
    ],
  },
]

export const QUICK_EMOJIS = ['👍', '✅', '🔥', '🎉', '❤️', '😄', '🙏', '👀']
const RECENT_KEY = 'chat_emoji_recent'

export function getRecentEmojis() {
  try { return JSON.parse(localStorage.getItem(RECENT_KEY) || '[]').slice(0, 16) } catch { return [] }
}
export function pushRecentEmoji(e) {
  try {
    const cur = getRecentEmojis().filter((x) => x !== e)
    localStorage.setItem(RECENT_KEY, JSON.stringify([e, ...cur].slice(0, 16)))
  } catch { /* yut */ }
}
export function searchEmojis(q) {
  const t = (q || '').trim().toLocaleLowerCase('tr')
  if (!t) return []
  const out = []
  for (const c of EMOJI_CATEGORIES) {
    for (const [e, kw] of c.items) {
      if (kw.includes(t)) out.push(e)
      if (out.length >= 48) return out
    }
  }
  return out
}
